export default __webpack_public_path__ + "static/media/service_5.7fb2bc70.jpg";